<template>
    <div class="dialog-screen">
        <div class="table-layout">
            <el-table class="thin" :data="pageDevcDefImpList" :height="tableHeight" ref="devcDefImpInfoTable" border style="width: 100%; " @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column label="源件" width="60" align="center">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="300" align="left" v-show="startFlag"></el-table-column>
                <el-table-column label="资产定义编码">
                    <el-table-column prop="innerCode" width="220">
                        <template slot-scope="rows">
                            <input class="inline-block" type="text" v-if="!rows.row.validateInfo.innerCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 65%" v-model="rows.row.innerCode" :title="rows.row.validateInfo.innerCode.errorMsg"/>
                            <input class="inline-block" type="text" v-else style="width:65%" @change="commonChangeEvent" v-model="rows.row.innerCode"/>
                            <a class="swb-btn-link fr inline-block" @click="setInnerCode(rows.row)">系统生成</a>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产定义名称">
                    <el-table-column prop="name" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.name.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.name" :title="rows.row.validateInfo.name.errorMsg"/>
                            <input type="text" v-else style="width:180px" @change="commonChangeEvent" v-model="rows.row.name"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产描述全称">
                    <el-table-column prop="name" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.title.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.title" :title="rows.row.validateInfo.title.errorMsg"/>
                            <input type="text" v-else style="width:180px" @change="commonChangeEvent" v-model="rows.row.title"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产分类编码">
                    <el-table-column prop="innerDevcCode" width="150" :render-header="setDevcCat">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcCode.errorMsg">
                                <span>{{rows.row.innerDevcCode}}</span>
                            </div>
                            <div v-else>{{rows.row.innerDevcCode}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产分类名称">
                    <el-table-column prop="innerDevcCatName" width="150">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcCode.errorMsg">
                                <span>{{rows.row.innerDevcCatName}}</span>
                            </div>
                            <div v-else>{{rows.row.innerDevcCatName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产品牌编码">
                    <el-table-column prop="innerDevcBrandCode" width="150" :render-header="setDevcBrand">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcBrandCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcBrandCode.errorMsg">
                                <span>{{rows.row.innerDevcBrandCode}}</span>
                            </div>
                            <div v-else>{{rows.row.innerDevcBrandCode}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产品牌名称">
                    <el-table-column prop="innerDevcBrandName" width="150">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcBrandCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcBrandCode.errorMsg">
                                <span>{{rows.row.innerDevcBrandName}}</span>
                            </div>
                            <div v-else>{{rows.row.innerDevcBrandName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="型号">
                    <el-table-column prop="model" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.model.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.model" :title="rows.row.validateInfo.model.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.model"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="规格">
                    <el-table-column prop="fixedSpec" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.fixedSpec.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.fixedSpec" :title="rows.row.validateInfo.fixedSpec.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.fixedSpec"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="单位">
                    <el-table-column prop="theUnit">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.theUnit.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.theUnit" :title="rows.row.validateInfo.theUnit.errorMsg"/>
                            <input type="text" v-else style="width:90%" @change="commonChangeEvent" v-model="rows.row.theUnit"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="管理方式" width="140" align="center" v-if="scopeId != null && scopeId == 4">
                    <el-table-column prop="assetType" width="140" align="center">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.assetType.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.assetType.errorMsg">
                                <el-select v-model="rows.row.assetType" class="select-warn">
                                    <el-option key="单品式管理" label="单品式管理" value="单品式管理"></el-option>
                                    <el-option key="批量式管理" label="批量式管理" value="批量式管理"></el-option>
                                </el-select>
                            </div>
                            <div v-else>
                                <el-select v-model="rows.row.assetType">
                                    <el-option key="单品式管理" label="单品式管理" value="单品式管理"></el-option>
                                    <el-option key="批量式管理" label="批量式管理" value="批量式管理"></el-option>
                                </el-select>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="使用方式" width="140" align="center">
                    <el-table-column prop="useManner" width="140" align="center">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.useManner" @change="commonChangeEvent">
                                <el-option v-for="item in devcUseMannerList" :key="item.text" :label="item.text" :value="item.text"/>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="定义完善程度" width="140" align="center" v-if="normalFlag">
                    <el-table-column prop="normalized" width="140" align="center">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.normalized.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.normalized.errorMsg">
                                <el-select v-model="rows.row.normalized" class="select-warn" @change="normalizedChange(rows.$index)">
                                    <el-option key="在账资产" label="在账资产" value="在账资产"></el-option>
                                    <el-option key="账外设备" label="账外设备" value="账外设备"></el-option>
                                </el-select>
                            </div>
                            <div v-else>
                                <el-select v-model="rows.row.normalized" @change="normalizedChange(rows.$index)">
                                    <el-option key="在账资产" label="在账资产" value="在账资产"></el-option>
                                    <el-option key="账外设备" label="账外设备" value="账外设备"></el-option>
                                </el-select>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="财务类别编码" width="140" align="center" v-if="normalFlag">
                    <el-table-column prop="assetKindCode" width="140" align="center">
                        <template slot-scope="rows">
                            <span v-if="rows.row.normalized == '在账资产'">
                                <input type="text" v-if="!rows.row.validateInfo.assetKindCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.assetKindCode" :title="rows.row.validateInfo.assetKindCode.errorMsg"/>
                                <input type="text" v-else style="width:100px" @change="commonChangeEvent(rows.row, 'assetKindCode')" v-model="rows.row.assetKindCode"/>
                            </span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="财务类别名称" width="100" v-if="normalFlag">
                    <el-table-column prop="assetKindName" width="100" align="left">
                        <template slot-scope="rows">
                            <span v-if="rows.row.normalized == '在账资产'">{{rows.row.assetKindName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="折旧分摊规则名称" v-if="normalFlag">
                    <el-table-column prop="deprSpecName" width="150">
                        <template slot-scope="rows">
                            <div v-if="rows.row.normalized == '在账资产'">{{rows.row.deprSpecName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="折旧分摊规则编码" v-if="normalFlag">
                    <el-table-column prop="deprSpecCode" width="150">
                        <template slot-scope="rows">
                            <div v-if="rows.row.normalized == '在账资产'">{{rows.row.deprSpecCode}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="使用年限(月)" align="center">
                    <el-table-column prop="durableLife" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.durableLife.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.durableLife" style="background-color: #edd28b; width: 90px" :title="rows.row.validateInfo.durableLife.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.durableLife" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="按金额管理" align="center">
                    <el-table-column prop="splitible" width="100" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.splitible" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="维保分组">
                    <el-table-column prop="devcGroupFullName" label="设置" width="150" :render-header="setDevcGroup">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcGroupFullName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcGroupFullName.errorMsg">
                                <span>{{rows.row.devcGroupFullName}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.devcGroupFullName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <!--<el-table-column label="先进先出" align="center">-->
                    <!--<el-table-column prop="stockFifo" width="200" align="center">-->
                        <!--<template slot-scope="rows">-->
                            <!--<input type="checkbox" v-model="rows.row.stockFifo" @change="commonChangeEvent"/>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                <!--</el-table-column>-->
                <el-table-column label="需要供应商提供唯一标识码" align="center">
                    <el-table-column prop="vendorUknoFlag" width="200" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.vendorUknoFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="需要安装" align="center">
                    <el-table-column prop="setupFlag" width="100" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.setupFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <!--<el-table-column label="含组装商品" align="center">-->
                    <!--<el-table-column prop="asmblFlag" width="100" align="center">-->
                        <!--<template slot-scope="rows">-->
                            <!--<input type="checkbox" v-model="rows.row.asmblFlag" @change="commonChangeEvent"/>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                <!--</el-table-column>-->
                <!--<el-table-column label="安装时完成组装" align="center">-->
                    <!--<el-table-column prop="asmblWhileSetup" width="100" align="center">-->
                        <!--<template slot-scope="rows">-->
                            <!--<input type="checkbox" v-model="rows.row.asmblWhileSetup" @change="commonChangeEvent"/>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                <!--</el-table-column>-->
                <!--<el-table-column label="组装件数量" align="center">-->
                    <!--<el-table-column prop="asmbAccCount" width="100" align="center">-->
                        <!--<template slot-scope="rows">-->
                            <!--<input class="align-right" v-if="!rows.row.validateInfo.asmbAccCount.validateOk" @change="commonChangeEvent" type="number" size="4" v-model="rows.row.asmbAccCount" style="background-color: #edd28b; width: 90px" :title="rows.row.validateInfo.asmbAccCount.errorMsg"/>-->
                            <!--<input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.asmbAccCount" style="width: 90px"/>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                <!--</el-table-column>-->
                <el-table-column label="用于采购" align="center">
                    <el-table-column prop="purchFlag" width="100" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.purchFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="必须集中采购" align="center">
                    <el-table-column prop="centBuyRequired" width="100" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" :disabled="!rows.row.purchFlag" v-model="rows.row.centBuyRequired" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
<!--                <el-table-column label="商品分类">-->
<!--                    <el-table-column prop="catName" label="设置" width="150" :render-header="setCat">-->
<!--                        <template slot-scope="rows">-->
<!--                            <div v-if="!rows.row.validateInfo.catName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.catName.errorMsg">-->
<!--                                &lt;!&ndash;<div v-if="rows.row.devcGoodsCatRelList != null && rows.row.devcGoodsCatRelList.length > 0">&ndash;&gt;-->
<!--                                &lt;!&ndash;<span>{{rows.row.catName}}</span>&ndash;&gt;-->
<!--                                &lt;!&ndash;<el-select v-model="rows.row.catId" @change="((event)=>{catChange(event, rows.row.rowNo)})">&ndash;&gt;-->
<!--                                &lt;!&ndash;<el-option v-for="item in rows.row.devcGoodsCatRelList" :label="item.goodsCatName" :value="item.goodsCatId"></el-option>&ndash;&gt;-->
<!--                                &lt;!&ndash;</el-select>&ndash;&gt;-->
<!--                                &lt;!&ndash;</div>&ndash;&gt;-->
<!--                                &lt;!&ndash;<span v-else>{{rows.row.catName}}</span>&ndash;&gt;-->
<!--                                <span>{{rows.row.catName}}</span>-->
<!--                            </div>-->
<!--                            <div v-else>-->
<!--                                &lt;!&ndash;<div v-if="rows.row.devcGoodsCatRelList != null && rows.row.devcGoodsCatRelList.length > 0">&ndash;&gt;-->
<!--                                &lt;!&ndash;<el-select v-model="rows.row.catId" @change="((event)=>{catChange(event, rows.row.rowNo)})">&ndash;&gt;-->
<!--                                &lt;!&ndash;<el-option v-for="item in rows.row.devcGoodsCatRelList" :label="item.goodsCatName" :value="item.goodsCatId"></el-option>&ndash;&gt;-->
<!--                                &lt;!&ndash;</el-select>&ndash;&gt;-->
<!--                                &lt;!&ndash;</div>&ndash;&gt;-->
<!--                                &lt;!&ndash;<span v-else>{{rows.row.catName}}</span>&ndash;&gt;-->
<!--                                <span>{{rows.row.catName}}</span>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                </el-table-column>-->
<!--                <el-table-column label="商品品牌">-->
<!--                    <el-table-column prop="brandName" width="150" :render-header="setBrand">-->
<!--                        <template slot-scope="rows">-->
<!--                            <div v-if="!rows.row.validateInfo.brandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.brandName.errorMsg">-->
<!--                                <span>{{rows.row.brandName}}</span>-->
<!--                            </div>-->
<!--                            <span v-else>{{rows.row.brandName}}</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                </el-table-column>-->
                <el-table-column label="描述">
                    <el-table-column prop="memo" width="160">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.memo.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.memo.errorMsg">
                                <input type="text" @change="commonChangeEvent" v-model="rows.row.memo"/>
                            </div>
                            <input type="text" v-else style="width:150px" @change="commonChangeEvent" v-model="rows.row.memo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10" @click="downloadDevcDefImpModel">导出全部资产定义</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doDevcDefImpModelImport">逐条检查导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateMerchtDevcDefImpModel(true)">逐条检查</div>
        </div>
    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openCategTreeSelectDlg, openBrandListSelectDlg, showDevcCatSelectDlg, showDevcBrandSelectDlg, showDevcGroupSelectDlg } from '../categ/selectDlg'
    import { showDevcGroupCatSelectDlg } from '../categ/selectDlg'
    import { getAssetKindListAll } from '../retailer/asset-comn'
    import { getMerchantBizParam } from '../asset/assetMain'

    import devcDefApi from '../../api/devcDef'
    import userApi from '../../api/user'

    export default {
        name: 'swb-mercht-devc-def-imp-check',
        desc: '资产定义导入检查',
        props: ['scopeId', 'fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageDevcDefImpList: {},
                devcDefImpDto: {
                    originalFileName: null,
                    impInfoList: [],
                    dumyBrandNames: []
                },
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                retailerInfo: null,
                virtualBrandStr: '',
                max_quantity_per_item: 500,
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                scopeId: null,
                updateWayFlag: false,
                devcUseMannerList: getEnumList("devcUseManner"),
                deviceKindList: [],
                deviceKindMap: {},
                autoGeneratedTitle: false,
                normalFlag: false
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            //
            let self = this;
            //
            let theLoading = MsgBox.loading();
            getAssetKindListAll(function (dataList) {
                self.deviceKindList = dataList;
                let deviceKindMap = dataList.toMap('code');
                delete deviceKindMap[''];
                self.deviceKindMap = deviceKindMap;
            });
            this.devcDefImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let devcDefImpInfoList = this.fileObj.extra.devcDefImpInfoList || [];
            devcDefImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    name: {validateOk: true},
                    catName: {validateOk: true},
                    brandName: {validateOk: true},
                    model: {validateOk: true},
                    fixedSpec: {validateOk: true},
                    title: {validateOk: true},
                    innerCode: {validateOk: true},
                    devcGroupFullName: {validateOk: true},
                    innerDevcCode: {validateOk: true},
                    innerDevcBrandCode: {validateOk: true},
                    theUnit: {validateOk: true},
                    assetKindCode: {validateOk: true},
                    deprSpecCode: {validateOk: true},
                    durableLife: {validateOk: true},
                    asmbAccCount: {validateOk: true},
                    memo: {validateOk: true},
                    assetType: {validateOk: true},
                    normalized: {validateOk: true}
                };
            });
            this.devcDefImpDto.impInfoList = devcDefImpInfoList;
            // 获取集团业务参数：是否自动生成资产定义全称
            getMerchantBizParam("asset.definition.full.name.auto.generated", function (result) {
                self.autoGeneratedTitle = Utils.isTrue(result);
            }, 0);
            getMerchantBizParam("finac.mgmt.enabled", function (result) {  // 财务管理
                self.normalFlag = Utils.isTrue(result);
            }, 0);
            //
            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageDevcDefImpInfoList();
            this.getCurrUserInfo();
            theLoading.close();
        },
        methods: {
            // 设置系统编码
            setInnerCode: function (row) {
                let self = this;
                let assetType = getEnumInfoWith("assetType", "name", "CommonDevc").value;
                if(row.assetType == '单品式管理') {
                    assetType = getEnumInfoWith("assetType", "name", "CommonDevc").value;
                } else if(row.assetType == '批量式管理') {
                    assetType = getEnumInfoWith("assetType", "name", "DurableDevc").value;
                }
                let params = {
                    assetType: assetType
                };
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getDefInnerCodeByAssetType(params, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        row.innerCode = result.data;
                        self.checkData();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.scopeId = scopeEntity.scopeId;
                    }
                });
            },
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            // 选中行
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            //自动合并数据行
            commonChangeEvent(row, fieldName){
                if(!Utils.isNoB(row)) {
                    if(fieldName == 'assetKindCode') {
                        let kindObj = this.deviceKindMap[row.assetKindCode];
                        if(kindObj != null){
                            row.assetKindId = kindObj.id;
                            row.assetKindName = kindObj.name;
                            row.assetKindCode = kindObj.code;
                            if(row.assetNature != kindObj.assetNature){
                                row.assetNature = kindObj.assetNature;
                            }
                            row.deprSpecId = kindObj.deprSpecId;
                            row.deprSpecCode = kindObj.deprSpecCode;
                            row.deprSpecName = kindObj.deprSpecName;
                        } else {
                            row.assetKindId = null;
                            row.assetKindName = null;
                            row.assetKindCode = null;
                            row.assetNature = 0;
                            row.deprSpecId = null;
                            row.deprSpecCode = null;
                            row.deprSpecName = null;
                        }
                    }
                }
                this.checkData();
            },
            normalizedChange: function (index) {
                let rows = this.devcDefImpDto.impInfoList || [];
                for (let i = 0; i < rows.length; i++) {
                    if (index == i) {
                        let devcDef = rows[i];
                        devcDef.assetKindId = null;
                        devcDef.assetKindName = null;
                        devcDef.assetKindCode = null;
                        devcDef.assetNature = null;
                        devcDef.deprSpecId = null;
                        devcDef.deprSpecCode = null;
                        devcDef.deprSpecName = null;
                    }
                }
                this.devcDefImpDto.impInfoList = Utils.merge([], rows);
            },
            dlgSetDevcDefImpDto: function (devcDefImpDto) {
                let self = this;
                //
                let devcDefImpInfoList = devcDefImpDto.impInfoList;
                devcDefImpInfoList.forEach(function (el) {
                    el.validateInfo = {
                        name: {validateOk: true},
                        catName: {validateOk: true},
                        brandName: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        title: {validateOk: true},
                        innerCode: {validateOk: true},
                        devcGroupFullName: {validateOk: true},
                        innerDevcCode: {validateOk: true},
                        innerDevcBrandCode: {validateOk: true},
                        theUnit: {validateOk: true},
                        assetKindCode: {validateOk: true},
                        deprSpecCode: {validateOk: true},
                        durableLife: {validateOk: true},
                        asmbAccCount: {validateOk: true},
                        memo: {validateOk: true},
                        assetType: {validateOk: true},
                        normalized: {validateOk: true}
                    };
                });
                self.devcDefImpDto = devcDefImpDto;
                setTimeout(
                    function () {
                        self.checkData();
                    }, 1000
                );

            },
            checkData () {
                let self = this;
                let rows = this.devcDefImpDto.impInfoList.clone();
                let itemLength = rows.length;
                let byItemFlag = itemLength > 500;
                let innerCodeMap = {};
                for(let i = 0; i < rows.length; i++) {
                    let devcDefImpDto = rows[i];
                    devcDefImpDto.validateInfo = {
                        name: {validateOk: true},
                        catName: {validateOk: true},
                        brandName: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        title: {validateOk: true},
                        innerCode: {validateOk: true},
                        devcGroupFullName: {validateOk: true},
                        innerDevcCode: {validateOk: true},
                        innerDevcBrandCode: {validateOk: true},
                        theUnit: {validateOk: true},
                        assetKindCode: {validateOk: true},
                        deprSpecCode: {validateOk: true},
                        durableLife: {validateOk: true},
                        asmbAccCount: {validateOk: true},
                        memo: {validateOk: true},
                        assetType: {validateOk: true},
                        normalized: {validateOk: true}
                    };
                    if(!devcDefImpDto.purchFlag) {
                        devcDefImpDto.centBuyRequired = false;
                    }
                    // 检查 [定义名称]
                    if(!Utils.isNoB(devcDefImpDto.name)) {
                        devcDefImpDto.name = this.replaceSL(devcDefImpDto.name, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.name)) {
                        devcDefImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[名称]单元不可为空"
                        };
                    } else if(devcDefImpDto.name.length > 30) {
                        devcDefImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[名称]单元长度最大30，当前[" + devcDefImpDto.name.length + "]"
                        };
                    }
                    // 检查 [自有分类]
                    if(devcDefImpDto.innerDevcCatId == null) {
                        devcDefImpDto.validateInfo.innerDevcCode = {
                            validateOk: false,
                            errorMsg: "[资产分类]未确定"
                        };
                    }
                    if(devcDefImpDto.assetType == null) {
                        devcDefImpDto.validateInfo.assetType = {
                            validateOk: false,
                            errorMsg: "[管理方式]未确定"
                        };
                    }
                    if (devcDefImpDto.normalized == null && Utils.isTrue(self.normalFlag)) {
                        devcDefImpDto.normalized = "在账资产";
                    }
//                    if((devcDefImpDto.innerDevcCode != null || devcDefImpDto.innerDevcCatName != null) && devcDefImpDto.innerDevcCatId == null) {
//                        devcDefImpDto.validateInfo.innerDevcCode = {
//                            validateOk: false,
//                            errorMsg: "[资产分类]尚未注册或未关联商品分类"
//                        };
//                    }
                    // 检查 [商品分类]
                    // if(devcDefImpDto.catId == null && !byItemFlag) {
                    //     devcDefImpDto.validateInfo.catName = {
                    //         validateOk: false,
                    //         errorMsg: "[商品分类]未确定"
                    //     };
                    // }
                    // 检查 [自有品牌]
                    if((devcDefImpDto.innerDevcBrandCode != null || devcDefImpDto.innerDevcBrandName != null) && devcDefImpDto.innerDevcBrandId == null) {
                        devcDefImpDto.validateInfo.innerDevcBrandCode = {
                            validateOk: false,
                            errorMsg: "[自有品牌]尚未注册或未关联平台品牌"
                        };
                    }
                    // 检查 [品牌]
                    // if(devcDefImpDto.brandId == null && !byItemFlag) {
                    //     devcDefImpDto.validateInfo.brandName = {
                    //         validateOk: false,
                    //         errorMsg: "此品牌不存在,请设置品牌或设置无名虚拟品牌"
                    //     };
                    // }
                    // 检查 [型号]
                    if(!Utils.isNoB(devcDefImpDto.model)) {
                        devcDefImpDto.model = this.replaceSL(devcDefImpDto.model, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.model)) {
                        devcDefImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号]单元不能为空"
                        };
                    } else if(devcDefImpDto.model.length > 30) {
                        devcDefImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号]单元长度最大30，当前[" + devcDefImpDto.model.length + "]"
                        };
                    }
                    // 检查 [规格]
                    if(!Utils.isNoB(devcDefImpDto.fixedSpec)) {
                        devcDefImpDto.fixedSpec = this.replaceSL(devcDefImpDto.fixedSpec, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.fixedSpec)) {
                        devcDefImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元不能为空"
                        };
                    } else if(devcDefImpDto.fixedSpec.length > 45) {
                        devcDefImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元长度最大45，当前[" + devcDefImpDto.fixedSpec.length + "]"
                        };
                    }
                    // 检查 [资产描述全称]
                    if(!Utils.isNoB(devcDefImpDto.title)) {
                        devcDefImpDto.title = this.replaceSL(devcDefImpDto.title, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.title)) {
                        if(Utils.isTrue(self.autoGeneratedTitle)) {
                            if (!Utils.isNoB(devcDefImpDto.name) && !Utils.isNoB(devcDefImpDto.model) && !Utils.isNoB(devcDefImpDto.fixedSpec)) {
                                devcDefImpDto.title = devcDefImpDto.name + '' + devcDefImpDto.model + '' + devcDefImpDto.fixedSpec;
                            }
                        }
                        if(Utils.isNoB(devcDefImpDto.title)) {
                            devcDefImpDto.validateInfo.title = {
                                validateOk: false,
                                errorMsg: "[资产描述全称]单元不可为空"
                            };
                        } else if(devcDefImpDto.title.length > 60) {
                            devcDefImpDto.validateInfo.title = {
                                validateOk: false,
                                errorMsg: "[资产描述全称]单元长度最大60，当前[" + devcDefImpDto.title.length + "]"
                            };
                        }
                    } else if(devcDefImpDto.title.length > 60) {
                        devcDefImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[资产描述全称]单元长度最大60，当前[" + devcDefImpDto.title.length + "]"
                        };
                    }
                    if(devcDefImpDto.id != null) {
                        devcDefImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
//                        devcDefImpDto.validateInfo.catName = {
//                            validateOk: false,
//                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
//                        };
//                         devcDefImpDto.validateInfo.brandName = {
//                             validateOk: false,
//                             errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
//                         };
                        devcDefImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.theUnit = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.innerCode = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                    }
                    let innerCode = devcDefImpDto.innerCode;
                    if(Utils.isNoB(innerCode)) {
                        devcDefImpDto.validateInfo.innerCode = {
                            validateOk: false,
                            errorMsg: "[定义编码]不能为空"
                        };
                    } else {
                        let rowNo = innerCodeMap[innerCode];
                        if(rowNo == null) {
                            innerCodeMap[innerCode] = devcDefImpDto.rowNo;
                        }
                        if(rowNo != null && rowNo != devcDefImpDto.rowNo) {
                            devcDefImpDto.validateInfo.innerCode = {
                                validateOk: false,
                                errorMsg: "行号为【" + rowNo + "】的定义编码与行号为【" + devcDefImpDto.rowNo + "】的定义编码相同，请修改"
                            };
                            if(!Utils.isTrue(devcDefImpDto.failed)) {
                                devcDefImpDto.failed = true;
                                devcDefImpDto.failDesc = "行号为【" + rowNo + "】的定义编码与行号为【" + devcDefImpDto.rowNo + "】的定义编码相同，请修改";
                            }
                        } else {
                            if(Utils.isNoB(devcDefImpDto.failDesc)) {
                                devcDefImpDto.failed = false;
                            }
                        }
                    }
                    // 检查 [单位]
                    if(!Utils.isNoB(devcDefImpDto.theUnit)) {
                        devcDefImpDto.theUnit = this.replaceSL(devcDefImpDto.theUnit, '');
                        if(devcDefImpDto.theUnit.length > 5) {
                            devcDefImpDto.validateInfo.theUnit = {
                                validateOk: false,
                                errorMsg: "[单位]单元长度最大5，当前[" + devcDefImpDto.theUnit.length + "]"
                            };
                        }
                    } else {
                        devcDefImpDto.validateInfo.theUnit = {
                            validateOk: false,
                            errorMsg: "[单位]单元不可为空"
                        };
                    }
                    // 检查财务类别编码
                    if(Utils.isNoB(devcDefImpDto.assetKindCode)) {
//                        devcDefImpDto.validateInfo.assetKindCode = {
//                            validateOk: false,
//                            errorMsg: "[财务类别编码]单元不可为空"
//                        };
                    }
                    // 检查修正 [使用年限(月)]
                    if(!Utils.isNoB(devcDefImpDto.durableLife)) {
                        if(devcDefImpDto.assetNature == 2) {
                            if(!Utils.isNaturalStr(devcDefImpDto.durableLife)) {
                                devcDefImpDto.validateInfo.durableLife = {
                                    validateOk: false,
                                    errorMsg: "[使用年限(月)]单元为 >= 0 的整数"
                                };
                            }
                        } else {
                            if(!Utils.isNaturalStr(devcDefImpDto.durableLife, true)) {
                                devcDefImpDto.validateInfo.durableLife = {
                                    validateOk: false,
                                    errorMsg: "[使用年限(月)]单元为 > 0 的整数"
                                };
                            }
                        }
                    } else if(Utils.isNoB(devcDefImpDto.durableLife)) {
                        devcDefImpDto.validateInfo.durableLife = {
                            validateOk: false,
                            errorMsg: "[使用年限(月)]单元不能为空"
                        };
                    }
                    // 检查修正 [组装件数量]
                    if(!Utils.isNoB(devcDefImpDto.asmbAccCount)) {
                        if(!Utils.isNaturalStr(devcDefImpDto.asmbAccCount) || devcDefImpDto.asmbAccCount < 0) {
                            devcDefImpDto.validateInfo.asmbAccCount = {
                                validateOk: false,
                                errorMsg: "[组装件数量]单元为 >= 0 的整数"
                            };
                        }
                    }
                    // 检查修正 [描述]
                    if(!Utils.isNoB(devcDefImpDto.memo)) {
                        if(devcDefImpDto.memo.length > 60) {
                            devcDefImpDto.validateInfo.memo = {
                                validateOk: false,
                                errorMsg: "[备注]单元长度最大60，当前[" + devcDefImpDto.memo.length + "]"
                            };
                        }
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.devcDefImpDto.impInfoList = rows;
                this.setPageDevcDefImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.devcDefImpDto.impInfoList.forEach(function (row) {
                        if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.devcDefImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageDevcDefImpInfoList: function () {
                let totalRows = this.devcDefImpDto.impInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageDevcDefImpList = rows;
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDevcDefImpInfoList();
            },
            downloadDevcDefImpModel: function () {
                devcDefApi.devcDefImpModelForExport(this.devcDefImpDto, function (result) {
                    if(result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                // 虚拟品牌校验
                let virtualBrandStr = this.virtualBrandStr;
                let virtualBrand = [];
                if(!Utils.isNoB(virtualBrandStr)) {
                    virtualBrand = virtualBrandStr.split('|');
                }
                this.devcDefImpDto.dumyBrandNames = virtualBrand;
                return this.devcDefImpDto;
            },
            setDevcGroup (h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let params = {
                                    filter: {
                                        level: 2
                                    },
                                    checkBox: false
                                };
                                showDevcGroupSelectDlg(params, function (devcGroup, theDlg) {
                                    theDlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.devcDefImpDto.impInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        //
                                        model.devcGroupId = devcGroup.id;
                                        model.devcGroupFullName = devcGroup.fullName;
                                        model.catId = null;
                                        model.catName = null;
                                    }
                                    self.checkData();
                                    return true;
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 设置分类
            setCat (h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                let multipleSelection = self.multipleSelection || [];
                                if(multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let devcGroupId = null;
                                for(let i = 0; i < multipleSelection.length; i++) {
                                    let multipleSelect = multipleSelection[i];
                                    if(Utils.isNoB(devcGroupId)) {
                                        devcGroupId = multipleSelect.devcGroupId;
                                    } else if(multipleSelect.devcGroupId != devcGroupId) {
                                        self.$message.warning("请选择相同维保分组的数据");
                                        return;
                                    }
                                }
                                if(Utils.isNoB(devcGroupId)) {
                                    let params = {
                                        multipleSelect: false
                                    };
                                    openCategTreeSelectDlg(params, [], function (catList) {
                                        catList = catList || [];
                                        let categ = catList[0];
                                        console.log(self.multipleSelection);
                                        for(let i = 0; i < self.multipleSelection.length; i++) {
                                            let tmpRow = self.multipleSelection[i];
                                            let model = self.devcDefImpDto.impInfoList.find(function (row) {
                                                return row.rowNo == tmpRow.rowNo;
                                            });
                                            //
                                            model.catId = categ.catId;
                                            model.catName = categ.catName;
                                        }
                                        self.checkData();
                                        return true;
                                    });
                                } else {
                                    let params = {
                                        filter: {
                                            groupId: devcGroupId,
                                            level: 2
                                        },
                                        checkBox: false,
                                    };
                                    showDevcGroupCatSelectDlg(params, function (resultData, theDlg) {
                                        theDlg.close();
                                        let categ = Utils.merge({}, resultData);
                                        //
                                        for(let i = 0; i < multipleSelection.length; i++) {
                                            let tmpRow = multipleSelection[i];
                                            let model = self.devcDefImpDto.impInfoList.find(function (row) {
                                                return row.rowNo == tmpRow.rowNo;
                                            });
                                            //
                                            model.catId = categ.catId;
                                            model.catName = categ.catName;
                                        }
                                        self.checkData();
                                    });
                                }
                            }
                        }
                    }, '设置'),
                ])
            },
            // 设置品牌
            setBrand(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行！");
                                    return;
                                }
                                let catIds = [];
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    let obj = self.multipleSelection[i];
                                    let catId = obj.catId;
                                    if(Utils.isNoB(catId)) {
                                        self.$message.warning("请先设置分类！");
                                        return;
                                    }
                                    if(!catIds.contains(catId)) {
                                        catIds.push(catId);
                                    }
                                }
                                if(catIds.length > 1) {
                                    self.$message.warning("勾选的行的分类必须一致！");
                                    return;
                                }
                                let params = {
                                    catId: catIds[0],
                                    showAll: false
                                };
                                openBrandListSelectDlg(false, params, function (brand) {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].brandId = brand.id;
                                        self.multipleSelection[i].brandName = brand.dispName;
                                    }
                                    self.checkData();
                                    return true;
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 选择行
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 逐条检查
            validateMerchtDevcDefImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                this.getDlgResult();
                let devcDefImpDto = this.devcDefImpDto;
                //
                let srcDevcDefImpInfoList = devcDefImpDto.impInfoList || [];
                let srcListLength = srcDevcDefImpInfoList.length;
                console.log(srcListLength);
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcDevcDefImpInfoList[checkNextIndex];
                let postData = Utils.merge({}, devcDefImpDto);
                postData.impInfoList = [srcImpInfo];
                postData.devcFlag = true;
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                devcDefApi.validateDevcDefImpModel(postData, function (result) {
                    theLoading.hide();
                    let callItem = result.data.impInfoList[0];
                    if(result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcDevcDefImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    devcDefImpDto.srcDevcDefImpInfoList = srcDevcDefImpInfoList;
                    self.devcDefImpDto = Utils.merge({}, devcDefImpDto);
                    self.checkData();
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    //
                    if(checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateMerchtDevcDefImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 逐条检查导入
            doDevcDefImpModelImport(){
                let self = this;
                this.getDlgResult();
                let devcDefImpDto = this.devcDefImpDto;
                // 判断全部的状态是否是ok
                let srcDeviceImpInfoList = devcDefImpDto.impInfoList || [];
                let srcListLength = srcDeviceImpInfoList.length;
                if(srcListLength > 500) {
                    //弹出确认框
                    this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.doDevcDefImpModelImportStart();
                    }).catch(function () {

                    });
                } else {
                    self.doDevcDefImpModelImportStart();
                }
            },
            // 开始导入
            doDevcDefImpModelImportStart(){
                this.startFlag = true;
                let srcDeviceImpDto = this.devcDefImpDto;
                //
                let impDto = {};
                impDto.merchantId = srcDeviceImpDto.merchantId;
                impDto.originalFileName = srcDeviceImpDto.originalFileName;
                impDto.dumyBrandNames = srcDeviceImpDto.dumyBrandNames;
                impDto.virtualType = srcDeviceImpDto.virtualType;
                impDto.updateWayFlag = Utils.isTrue(this.updateWayFlag);
                //
                this.startDone(impDto);
            },
            startDone(impDto){
                let self = this;
                let nextIndex = this.nextIndex;
                let srcDeviceImpDto = this.devcDefImpDto;
                let srcDeviceImpInfoList = srcDeviceImpDto.impInfoList || [];
                let srcListLength = srcDeviceImpInfoList.length;
                let srcImpInfo = srcDeviceImpInfoList[nextIndex];
                impDto.impInfoList = [srcImpInfo];
                impDto.devcFlag = true;
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                devcDefApi.doDevcDefImpModelImport(impDto, function (result) {
                    theLoading.close();
                    let resultDto = result.data;
                    if(result.type == 'info') {
                        srcImpInfo.failed = false;
                        srcImpInfo.failDesc = null;
                    } else {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = result.message;
                    }
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (nextIndex + 1) / pageSize;
                    let pageNumber2 = (nextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    if(!Utils.isNoB(resultDto) && !Utils.isNoB(resultDto.errMsg)) {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = resultDto.errMsg;
                        self.handlePageChange(pageNumber);
                        MsgBox.warning("源件行号：" + srcImpInfo.rowNo + "】:" + resultDto.errMsg);
                    } else {
                        self.handlePageChange(pageNumber);
                        //
                        if(nextIndex < (srcListLength - 1)) {
                            self.nextIndex = nextIndex + 1;
                            self.startDone(impDto);
                        } else {
                            self.$emit('other-close');
                        }
                    }
                });
            },
            replaceSL(str, char){
                if(!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
            setDevcCat(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                showDevcCatSelectDlg({
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false,
                                        level: 3
                                    }
                                }, function (devcCat, theDlg) {
                                    theDlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let row = self.multipleSelection[i];
                                        row.innerDevcCatId = devcCat.id;
                                        row.innerDevcCode = devcCat.code;
                                        row.innerDevcCatName = devcCat.name;
                                        if(Utils.isNoB(row.durableLife) && !Utils.isNoB(devcCat.durableLife)) {
                                            row.durableLife = devcCat.durableLife;
                                        }
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            setDevcBrand(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                showDevcBrandSelectDlg({
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false
                                    }
                                }, function (devcBrand, theDlg) {
                                    theDlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].innerDevcBrandId = devcBrand.id;
                                        self.multipleSelection[i].innerDevcBrandCode = devcBrand.code;
                                        self.multipleSelection[i].innerDevcBrandName = devcBrand.name;
                                        if(Utils.isNoB(self.multipleSelection[i].brandId) && !Utils.isNoB(devcBrand.sysBrandId) && devcBrand.sysBrandId != -1) {
                                            self.multipleSelection[i].brandId = devcBrand.sysBrandId;
                                            self.multipleSelection[i].brandName = devcBrand.sysBrandName;
                                        }
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            catChange(event, rowNo){
                let impInfoList = this.devcDefImpDto.impInfoList;
                let theItem = impInfoList.find(function (item) {
                    return item.rowNo == rowNo;
                });
                let devcGoodsCatRelList = theItem.devcGoodsCatRelList;
                let catRelItem = devcGoodsCatRelList.find(function (item) {
                    return item.goodsCatId == theItem.catId;
                });
                theItem.catName = catRelItem.goodsCatName;
                this.checkData();
            }
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcDefImpCheck.vue